import React, { useState } from "react";
import Header from "./Header";
import "../assets/styles/Consent.css";
import { TOEFL_PROGRAM_ID } from "../constants/Constants";

const Consent = ({ toNextPage }) => {
  const [agreeCheckbox, setAgreeCheckbox] = useState(false);
  const programId = sessionStorage.getItem("program_id");
  return (
    <div>
      <Header />

      <div className="consent-container">
        <h3>CONSENT FOR COLLECTION AND USE OF BIOMETRIC DATA </h3>
        <div className="separation-line"></div>
        <div>
          <h4>Notice and Consent</h4>
          <p>
            This notice and consent for the collection and use of biometric data
            (the "Consent") describes how we and our service providers collect
            and process your biometric data in connection with the identity
            verification services we use (the "Services").
          </p>
          <p>
            <b>
              Please read this Consent carefully and in full before agreeing to
              the collection and use of your biometric data.{" "}
            </b>
          </p>
          <h4>1. What is Biometric Data?</h4>
          <p>
            As used in this Consent, "biometric data" means, collectively,
            "biometric identifiers" and "biometric information." Common examples
            of "biometric identifiers" include retina or iris scans,
            fingerprints, voiceprints, and scans of hand or face geometry.
            "Biometric information" means any information, regardless of how it
            is captured, converted, stored, or shared, based on an individual's
            biometric identifier and used to identify an individual.
          </p>
          <h4>2. What Biometric Data Do We Collect?</h4>
          <p>
            When you use the Services, we or our service providers may collect
            biometric data comprising a scan of your face geometry. More
            specifically, the Services may require you to upload an image of
            your government-issued or other identification document, as well as
            a photograph or "selfie" taken using your mobile or other device.
            The Services use these images to detect the geometry of your face
            (sometimes called a "faceprint").
          </p>
          <h4>3. How Do We Use Your Biometric Data?</h4>
          <p>
            We and our service providers may use your biometric data for the
            following purposes:
          </p>
          <ul>
            <li>to assist with our verification of your identity;</li>
            <li>
              and to comply with our legal or contractual obligations; and
            </li>
            <li>to improve the Services.</li>
          </ul>
          <h4>4. To Whom Do We Disclose Your Biometric Data?</h4>
          <p>
            As noted above, we use service providers to assist with the
            provision of the Services. We may disclose your biometric data to
            those service providers, and they may further disclose your
            biometric data to the service providers that help them provide the
            Services. We and our service providers may also disclose your
            biometric data to other third parties (to the extent permitted by
            law) to (i) enforce our or their legal rights, (ii) to comply with
            our or their legal and contractual obligations, (iii) to cooperate
            with law enforcement agencies concerning conduct or activity that we
            or they reasonably believe may violate applicable law, (iv) if
            required by a subpoena, warrant, or other valid court order; (v) to
            prevent harm, loss, or injury to others; and (vi) with your or your
            authorized representative’s express consent. Neither we nor our
            service providers will sell, lease, trade, or otherwise profit from
            your biometric data.{" "}
          </p>
          <h4>5. How Long Do We Retain Your Biometric Data</h4>
          <p>
            We and our service providers may retain your biometric data until
            (i) the initial purposes for collecting your biometric data have
            been satisfied; or (ii) within 3 years of your last interaction with
            us, whichever occurs first. Upon the occurrence of either (i) or
            (ii), we will permanently destroy your biometric data.
          </p>
          <h4>6. How Do We Secure Your Biometric Data?</h4>
          <p>
            We and our service providers use a reasonable standard of care to
            store, transmit, and protect from disclosure your biometric data.
            Such storage, transmission, and protection from disclosure will be
            performed in a manner that is the same as or more protective than
            the manner in which we and our service providers (as applicable)
            store, transmit, and protect from disclosure other confidential and
            sensitive information.
          </p>
          <h4>7. Are There Alternatives to Our Use of Your Biometric Data?</h4>
          <p>
            If you do not wish for us to collect and use your biometric data as
            described above, please contact the business entity utilizing our
            services directly to ask if there are alternative methods to verify
            your identity.
          </p>
        </div>
        <div className="consent-contents">
          <input
            type="checkbox"
            className="consent-checkbox"
            onClick={() => setAgreeCheckbox((prev) => !prev)}
          />
          <label>I agree</label>
        </div>
      </div>

      <div className="consent-button-container">
        <button
          disabled={!agreeCheckbox}
          className={`continue-button ${
            programId == TOEFL_PROGRAM_ID ? "toefl-button-bg" : "gre-button-bg"
          }`}
          onClick={toNextPage}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default Consent;
